import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import formatDate from "helpers/format-date";
import { useGlobalContext } from "context/global";
import { formatTitle } from "helpers/format-title";

const BlogItem = ({ blog }) => {
	const { translation, language } = useGlobalContext();
	const { title, featuredImage: image, excerpt, date, handle, category } = blog;

	return (
		<div className="flex flex-col px-5 m-auto">
			<Image className="aspect-video" image={image?.asset} alt={image?.alt} />
			<div className="py-5">
				<span className="text-gray-500">{formatDate(date, language)}</span>
				<Link to={`/blogs/${category.handle}/${handle}`}><h3 className="py-3">{formatTitle(title)}</h3></Link>
				<div className="h-[75px] text-clamp">{excerpt}</div>
				<Link to={`/blogs/${category.handle}/${handle}`} className="btn-read-more mt-4">
					{translation?.blog?.readMore}
				</Link>
			</div>
		</div>
	);
};

export default BlogItem;
